// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pic_box":"pic_box-197C0MCO","pic":"pic-3pLjNC7L","trans":"trans-2vTv6Bxc","mask":"mask-2MxiMKQ9","title":"title-2iNluVVc","tip":"tip-2S7d_euh","list":"list-3gdR5s9m"};